module.exports = __webpack_public_path__ + "img/diners_visacal.c3c27fff.png";